import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import "@hotwired/turbo-rails";
import './flatpickr';
import './quill';

// loads the Icon plugin
UIkit.use(Icons);
